module.exports = __webpack_public_path__ + "img/product.e70cc118.png";